import React, { useEffect, useState, useRef } from "react";
import { loaderReducer } from "../../components/toolkit/loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { syncReducer } from "../../components/toolkit/syncReducer";
import axios from "axios";
import { Card } from "antd";
import { Pagination } from "antd";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { Modal, Button } from "antd";
import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { useCan } from "../../utils/permissions";

// import components here
import Layout from "../../components/layout";
import Sidebar from "../../components/sidebar";
import "./index.css";
import SubHeader2 from "../../components/subHeader2";
import Info from "./info";
import Task from "./tasks";
import Notes from "./notes";
import ClosingQuestioner from "./ClosingQuestioner";
import {
  workorderSearchfilter,
  workOrderFilterAll,
  getWorkOrderCount,
} from "../../functions/workorder";
import CustomMarker from "./CustomMarker/CustomMarker";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { useNavigate } from "react-router-dom";
// import icons here
import { AiOutlineSync } from "react-icons/ai";
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaMap } from "react-icons/fa";
// import userCheck from "../../utils/checkUser";

const getMarkerIcon = (status) => {
  // console.log("sssssssssssssssssssssss", status);

  switch (status?.toLowerCase()) {
    case "scheduled":
      return "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
    case "completed":
      return "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
    case "onhold":
      return "http://maps.google.com/mapfiles/ms/icons/orange-dot.png";
    case "rejected":
      return "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
    case "pending":
      return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
    case "rescheduled":
      return "http://maps.google.com/mapfiles/ms/icons/purple-dot.png";
    default:
      return "http://maps.google.com/mapfiles/ms/icons/gray-dot.png";
  }
};
const Index = ({ children }) => {
  var { search } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const userName = cookies.get("userName");
  const { sync } = useSelector((state) => ({ ...state }));
  const title = location.state?.title; // Safe check in case state is undefined
  const [searchParams, setSearchParams] = useSearchParams();
  const [workOrders, setWorkOrders] = useState([]);
  const [tranId, setTranId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalWorkOrders, setTotalWorkOrders] = useState(0); // You need to set this value based on the total number of work orders
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [activeComponent, setActiveComponent] = useState("info");
  const [priority, setPriority] = useState("");
  const [apptStatus, setApptStatus] = useState("");
  const [reconciliationStatus, setReconciliationStatus] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [radioData, setRadioData] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc");
  const [techName, setTechName] = useState("");
  const [callRadioData, setCallRadioData] = useState(false);
  const [filterStatus, filtertatus] = useState(false);
  const [radioDatastatus, setradioDatastatus] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const can = useCan();
  const canDeleteWorkOrder = can("workOrders", "delete");

  const handleComplete = () => {
    setIsComplete(!isComplete);
  };

  // make state here
  const [selectedWorkOrderToDelete, setSelectedWorkOrderToDelete] = useState(
    []
  );
  // console.log("selectedWorkOrderToDelete", selectedWorkOrderToDelete);
  const [isRefresh, setIsRefresh] = useState({ isRefresh: false, tranId: "" });
  const [workOrderCount, setWorkOrderCount] = useState("");
  // const [showButton, setShowButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // open google map
  const [openGoogleMap, setOpenGoogleMap] = useState(false);
  const [openGoogleMapDetailsModal, setOpenGoogleMapDetailsModal] =
    useState(false);
  const [
    selectedWorkOrderDataDisplayToMapModal,
    setSelectedWorkOrderDataDisplayToMapModal,
  ] = useState({});
  const [mapInstance, setMapInstance] = useState(null);
  // console.log("mapInstance", mapInstance);

  const [markers, setMarkers] = useState([]);
  const [showCompleted, setShowCompleted] = useState(false);
  const handleShowCompleted = () => {
    setShowCompleted((prev) => !prev);
    // console.log("showCompleted", showCompleted);
  };
  // console.log("markersmarkersmarkers",markers);

  // useEffect(() => {
  //   if (mapInstance) {
  //     console.log("Marker clicked 84:", workOrders);
  //     const markerData = workOrders?.map((wo) => ({
  //       tranId: wo?.tranId,
  //       address: wo?.address,
  //       status: wo?.apptStatus,
  //       jobType: wo?.jobType,
  //       contact_details: {
  //         phone: wo?.phone || "",
  //       },
  //       point_of_contact: wo?.techName,
  //       position: {
  //         lat: wo?.lat || 0.0,
  //         lng: wo?.long || 0.0,
  //       },
  //     }));

  //     const newMarkers = markerData.map((data) => {
  //       console.log("Marker clicked 93:", data);

  //       const marker = new window.google.maps.Marker({
  //         position: data?.position,
  //         map: mapInstance,
  //         address: data?.address,
  //         status: data?.reconciliationStatus,
  //         jobType: data?.jobType,
  //         contact_details: {
  //           email: data?.reconciliationStatus || "",
  //           phone: data?.phone || "",
  //         },
  //         point_of_contact: data?.techName || "",
  //       });

  //       // Add click listener to open modal with marker-specific details
  //       marker.addListener("click", () => {
  //         console.log("Marker clicked:", data);
  //         setSelectedWorkOrderDataDisplayToMapModal({
  //           ...data,
  //         });
  //         setOpenGoogleMapDetailsModal(true);
  //       });

  //       return marker;
  //     });

  //     setMarkers(newMarkers);
  //   }
  // }, [mapInstance, openGoogleMap]);

  // Watch for changes to tranId and set isRefresh accordingly

  useEffect(() => {
    if (mapInstance) {
      // const markerData = workOrders?.map((wo) => {
      //   // Find primary contact (if available)
      //   const primaryContact = wo?.customers?.find(
      //     (contact) => contact.isPrimary
      //   );

      //   return {
      //     status: wo?.apptStatus,
      //     position: { lat: wo?.lat || 0.0, lng: wo?.long || 0.0 },
      //     address: wo?.address,
      //     jobType: wo?.jobType,
      //     tranId: wo?.tranId,
      //     contact_details: {
      //       phone: primaryContact?.phone || wo?.phone || "",
      //       name: primaryContact?.entityid || "",
      //       email: primaryContact?.email || "",
      //       jobTitle: primaryContact?.jobtitle || "",
      //     },
      //     apptDate: wo?.apptDate,
      //     point_of_contact: wo?.techName,
      //     totalSurvayCount: wo?.totalSurveyCount,
      //   };
      // });
      // console.log("markerData", markerData);
      const markerData = workOrders
        ?.filter(
          (wo) => showCompleted || wo?.apptStatus?.toLowerCase() !== "completed"
        )
        ?.map((wo) => {
          const primaryContact = wo?.customers?.find((c) => c.isPrimary);
          return {
            status: wo?.apptStatus,
            position: { lat: wo?.lat || 0.0, lng: wo?.long || 0.0 },
            address: wo?.address,
            jobType: wo?.jobType,
            tranId: wo?.tranId,
            contact_details: {
              phone: primaryContact?.phone || wo?.phone || "",
              name: primaryContact?.entityid || "",
              email: primaryContact?.email || "",
              jobTitle: primaryContact?.jobtitle || "",
            },
            apptDate: wo?.apptDate,
            point_of_contact: wo?.techName,
            totalSurvayCount: wo?.totalSurveyCount,
          };
        });

      const newMarkers = markerData.map((data) => {
        console.log("Marker clicked 93:", data);
        const marker = new window.google.maps.Marker({
          position: data?.position,
          map: mapInstance,
          icon: getMarkerIcon(data?.status),
        });

        // clickable marker
        marker.addListener("click", () => {
          setSelectedWorkOrderDataDisplayToMapModal({ ...data });
          setOpenGoogleMapDetailsModal(true);
        });

        return marker;
      });

      setMarkers(newMarkers);
    }
  }, [mapInstance, openGoogleMap, showCompleted]);
  useEffect(() => {
    if (tranId === "") {
      // If tranId is empty, set isRefresh to false
      setIsRefresh({ isRefresh: false, tranId: "" });
    } else if (isRefresh.tranId === tranId) {
      // If tranId matches the expected one, set isRefresh to true
      setIsRefresh((prevState) => ({
        ...prevState,
        isRefresh: true,
      }));
    } else if (isRefresh.tranId !== "") {
      // If tranId doesn't match or is empty, set isRefresh to false and reset tranId
      setIsRefresh({ isRefresh: false, tranId: "" });
    }
  }, [isRefresh.tranId]); // This will trigger when tranId changes

  useEffect(() => {
    getOrderCount();
  }, []);

  // check user is valid or not
  // useEffect(() => {
  //   setShowButton(userCheck());

  // }, []);


  const openDeletePopUp = () => {
    // Open the modal
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDateSortClick = () => {
    setSortOrder(prev => (prev === "desc" ? "asc" : "desc"));
  };
  const requestIdRef = useRef(0);


  const fetchWorkOrders = async (opts = {}) => {
    const {
      page = currentPage,
      order = sortOrder,
    } = opts;

    setCallRadioData(false);
    setRadioData([]);
    dispatch(loaderReducer(true));
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/workOrders?page=${page}&perPage=10&sortOrder=${order}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();

      dispatch(loaderReducer(false));
      setWorkOrders(data.workOrders.workOrders);
      setTotalWorkOrders(data.workOrders.totalWorkOrders);

      const firstTranId = location.state?.tranId ?? data.workOrders.workOrders[0]?.tranId ?? "";
      setTranId(firstTranId);

      dispatch(syncReducer(""));
    } catch (error) {
      dispatch(loaderReducer(false));
      dispatch(syncReducer(""));
    }
  };


  useEffect(() => {
    if (!searchValue && !filterStatus) {
      fetchWorkOrders({ page: currentPage, order: sortOrder });
    }
    if (filterStatus) {
      fetchFilterAll(radioDatastatus);
    }
    setSelectedCardIndex(0);
  }, [currentPage, sortOrder, sync]);


  let searchValue = location.state?.tranId || title;

  // console.log("searchValue====>>>>>", searchValue, "<?>", searchText);

  // useEffect(() => {
  //   if (!searchValue && radioData==="" && !callRadioData) {
  //     fetchWorkOrders();
  //   }
  //   if (radioData!=="" && callRadioData){
  //     fetchFilterAll()
  //   }
  //   setSelectedCardIndex(0);
  // }, [currentPage,sortOrder,sync,radioData,callRadioData]);

  useEffect(() => {
    if (!searchValue && !filterStatus) {
      fetchWorkOrders();
    }
    if (filterStatus) {
      fetchFilterAll(radioDatastatus);
    }
    setSelectedCardIndex(0);
  }, [currentPage, sortOrder, sync]);

  useEffect(() => {
    if (searchValue && !filterStatus) {
      dispatch(loaderReducer(true));
      workorderSearch(searchValue);
    }
  }, [searchValue]);
  useEffect(() => {
    if (searchValue && searchText !== searchValue) {
      setSearchText(searchValue);
    }
  }, [searchValue]);

  const clickHandler = (index, t) => {
    setOpenGoogleMap(false);
    setOpenGoogleMapDetailsModal(false);
    setSelectedWorkOrderDataDisplayToMapModal(t);
    setSelectedCardIndex(index);
    setTranId(t.tranId);
    setPriority(t.priority);
    setApptStatus(t.apptStatus);
    setReconciliationStatus(t.reconciliationStatus);
    setSpecialInstructions(t.specialInstructions);
    setTechName(t.techName);

    // navigate("/work-order/info", { state: { tranId: t } });
  };

  // const workorderSearch = async () => {
  //   setCallRadioData(false);
  //   setRadioData([]);
  //   dispatch(loaderReducer(true));
  //   try {
  //     if (searchText.length > 0) {
  //       await workorderSearchfilter(token, searchText).then((res) => {

  //         dispatch(loaderReducer(false));
  //         setWorkOrders(res.data.data.workOrders);
  //         setTotalWorkOrders(res.data.data.workOrders.length);
  //         searchValue = "";
  //       });
  //     } else if (searchValue) {
  //       const res = await workorderSearchfilter(token, searchValue);
  //       dispatch(loaderReducer(false));
  //       setWorkOrders(res.data.data.workOrders);
  //       setTotalWorkOrders(res.data.data.workOrders.length);
  //       clickHandler(0, res.data.data.workOrders[0]);
  //       // console.log("console=>", res.data.data[0]);
  //       searchValue = "";
  //       setSearchParams((params) => {
  //         params.delete("orderId");
  //         return params;
  //       });
  //     } else {
  //       fetchWorkOrders();
  //     }
  //   } catch (error) {
  //     dispatch(loaderReducer(false));
  //     console.log(error);
  //   }
  // };
  // debounce helper
  // const useDebounce = (callback, delay) => {
  //   const timer = useRef();

  //   const debouncedFunction = (...args) => {
  //     clearTimeout(timer.current);
  //     timer.current = setTimeout(() => {
  //       callback(...args);
  //     }, delay);
  //   };

  //   return debouncedFunction;
  // };

  // // --- main function ---
  // const workorderSearch = async (query) => {
  //   setCallRadioData(false);
  //   setRadioData([]);

  //   if (!query || query.trim() === "") {
  //     fetchWorkOrders(); // fallback
  //     return;
  //   }

  //   // dispatch(loaderReducer(true)); // show loader only for final request

  //   try {
  //     const res = await workorderSearchfilter(token, query);
  //     setWorkOrders(res.data.data.workOrders);
  //     setTotalWorkOrders(res.data.data.workOrders.length);
  //     if (!searchText) clickHandler(0, res.data.data.workOrders[0]);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     dispatch(loaderReducer(false)); // hide loader once done
  //   }
  // };
  // const debouncedSearch = useDebounce(workorderSearch, 500); // 500ms delay
  // 👇 Debounce hook
  const useDebounce = (callback, delay) => {
    const timer = useRef();

    const debouncedFunction = (...args) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        callback(...args); // API call
      }, delay);
    };

    return debouncedFunction;
  };

  // 👇 API caller function (no loader start here)
  const workorderSearch = async (query) => {
    setCallRadioData(false);
    setRadioData([]);

    if (!query || query.trim() === "") {
      fetchWorkOrders();
      return;
    }

    try {
      const res = await workorderSearchfilter(token, query);
      setWorkOrders(res.data.data.workOrders);
      setTotalWorkOrders(res.data.data.workOrders.length);
      if (!searchText) clickHandler(0, res.data.data.workOrders[0]);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(loaderReducer(false)); // stop loader after API finishes
    }
  };

  // 👇 Debounced + loader starter
  const debouncedSearch = useDebounce((q) => {
    dispatch(loaderReducer(true)); // start loader when debounce completes
    workorderSearch(q);
  }, 500);

  // useEffect(() => {
  //   // if (searchValue) {
  //   //   setSearchText(searchValue);
  //   // }

  //   workorderSearch();
  // }, [searchText]);

  const fetchFilterAll = async (radioData) => {
    console.log("radioData", radioData);
    dispatch(loaderReducer(true));
    filtertatus(true);
    setradioDatastatus(radioData);
    try {
      await workOrderFilterAll(token, radioData, currentPage, sortOrder)
        .then((res) => {
          dispatch(loaderReducer(false));
          setWorkOrders(res.data.data.workOrders);
          setTotalWorkOrders(res.data.totalWorkOrders);
          clickHandler(0, res.data.data.workOrders[0]);
          // console.log("res.data=============>>>>>",res.data);
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          // console.log(err);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      // console.log(error);
    }
    // setCallRadioData(false)
  };

  // make function for select work order to delete
  const getOrderCount = async () => {
    try {
      await getWorkOrderCount(token).then((res) => {
        setWorkOrderCount(res.data.data);
      });
    } catch (error) { }
  };

  const handleSelectAllTheWorkOrder = () => {
    // If all work orders are already selected, deselect them
    if (selectedWorkOrderToDelete.length === workOrders.length) {
      setSelectedWorkOrderToDelete([]); // Deselect all
    } else {
      // Otherwise, select all work orders on the current page
      const allTranIds = workOrders.map((workOrder) => workOrder.tranId);
      setSelectedWorkOrderToDelete(allTranIds); // Select all
    }
  };

  const selectWordOrderForDelete = (i, d) => {
    // Check if the work order is already selected
    setSelectedWorkOrderToDelete((prevSelectedWorkOrders) => {
      if (prevSelectedWorkOrders.includes(d.tranId)) {
        // If the work order is already in the array, remove it (deselect it)
        return prevSelectedWorkOrders.filter((id) => id !== d.tranId);
      } else {
        // If the work order is not in the array, add it (select it)
        return [...prevSelectedWorkOrders, d.tranId];
      }
    });
  };

  // Get the count of selected work orders
  const selectedCount = selectedWorkOrderToDelete.length;

  // make function for delete work order
  const handleDeleteWorkOrder = async (i, d) => {
    dispatch(loaderReducer(true));
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/workOrders/delete-work-order`,
        {
          data: {
            workOrder_id: selectedWorkOrderToDelete,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Work order deleted successfully");
      getOrderCount();
      dispatch(loaderReducer(false));
      handleCancel();
      setSelectedWorkOrderToDelete([]);
      fetchWorkOrders();
    } catch (error) {
      console.log("Error In Delete API", error);
      toast.error("An error occurred during Delete work order");
    }
  };

  // make function for individual sync
  const handleIndividualSync = async () => {
    dispatch(loaderReducer(true));
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/sync/individual-sync/${tranId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      dispatch(loaderReducer(false));
      setIsRefresh({ isRefresh: true, tranId: tranId });
      toast.success("Individual sync completed successfully");
    } catch (error) {
      console.error("Individual Sync 293:", error);
      dispatch(loaderReducer(false));
      toast.error("An error occurred during individual sync work order");
    }

    //
  };

  const sidebarData = () =>
    workOrders?.length === 0
      ? "No Data found."
      : workOrders &&
      workOrders?.map((d, i) => (
        <div
          className={`mt-3 ${selectedCardIndex === i ? "selected-card" : ""}`}
          key={d.tranId + i}
        >
          <Card
            hoverable
            // style={{ height: "10rem" }}
            className="cardcls"
            onClick={() => clickHandler(i, d)}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div
                className="prioritycls"
                style={{
                  backgroundColor:
                    d.priority === "Low"
                      ? "#C2CDDD"
                      : d.priority === "High"
                        ? "#F47E75"
                        : d.priority === "Medium"
                          ? "#4585B2"
                          : d.priority === "Urgent"
                            ? "#FF3535"
                            : "#414C60",
                  color: "white",
                }}
              >{`PRIORITY : ${d.priority}`}</div>
              <div className="d-flex align-items-center gap-3">
                <div>
                  {d.apptDate === ""
                    ? ""
                    : d.apptDate === "Invalid date"
                      ? ""
                      : new Date(d.apptDate).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                </div>
                {canDeleteWorkOrder && (
                  <div>
                    <input
                      type="checkbox"
                      // onClick={(id) => selectWordOrderForDelete(i, d)}
                      checked={selectedWorkOrderToDelete.includes(d.tranId)} // Reflect if work order is selected
                      onChange={() => selectWordOrderForDelete(i, d)} // Call the selection/deselection handler
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="mt-2">
              #{d.tranId} | {d.jobType}
            </div>
            <hr style={{ margin: "0.5rem" }} />
            <div style={{ fontSize: "12px" }}>
              <div style={{ fontWeight: "600" }}>{d.address}</div>
              <div>{`${d.specialInstructions
                ?.substring(0, 40)
                .trim()}...`}</div>
            </div>
          </Card>
        </div>
      ));
  // console.log("searchText=>", totalWorkOrders);

  const handleOpenMap = () => {
    setOpenGoogleMap(!openGoogleMap);
    setMapInstance(null); // Reset mapInstance to ensure re-initialization
  };

  const handleOpenGoogleMapDetailsModal = (e) => {
    setOpenGoogleMapDetailsModal(!openGoogleMapDetailsModal);
  };

  const handleCloseGoogleMapDetailsModal = () => {
    setOpenGoogleMapDetailsModal(!openGoogleMapDetailsModal);
  };

  const onMapClick = (event) => {
    console.log("Map clicked at:", event.latLng.lat(), event.latLng.lng());
  };

  const handleMapLoad = (map) => {
    setMapInstance(map);
  };

  const redirectToWorkOrderPage = (tranId) => {
    setOpenGoogleMapDetailsModal(false);
    setOpenGoogleMap(false);
    const selectedWorkOrder = workOrders.find((wo) => wo.tranId === tranId);
    if (selectedWorkOrder) {
      setSelectedWorkOrderDataDisplayToMapModal(selectedWorkOrder);
      setSelectedCardIndex(workOrders.indexOf(selectedWorkOrder));
      setTranId(selectedWorkOrder.tranId);
      setPriority(selectedWorkOrder.priority);
      setApptStatus(selectedWorkOrder.apptStatus);
      setReconciliationStatus(selectedWorkOrder.reconciliationStatus);
      setSpecialInstructions(selectedWorkOrder.specialInstructions);
      setTechName(selectedWorkOrder.techName);
    }

    // 3) Navigate to the same /work-order page but include a unique query param
    //    so React Router sees it as a new route and re-renders.
    navigate(`/work-order?tranId=${tranId}&ts=${Date.now()}`, {
      replace: true,
    });
  };

  return (
    <>
      <Layout
        sidebarContent={
          <Sidebar
            arg={{
              searchText,
              setSearchText,
              radioData,
              setRadioData,
              fetchFilterAll,
              workorderSearch,
              handleDateSortClick,
              sortOrder,
              setSortOrder,
              totalWorkOrders,
              setCurrentPage,
              setCallRadioData,
              handleDeleteWorkOrder,
              selectedWorkOrderToDelete,
              workOrderCount,
              handleSelectAllTheWorkOrder,
              handleOpenMap,
              debouncedSearch,
            }}
          >
            {sidebarData()}
            <Pagination
              className="mt-2"
              current={currentPage}
              total={totalWorkOrders} // You need to know the total number of work orders
              pageSize={10}
              showSizeChanger={false}
              onChange={(page) => setCurrentPage(page)}
              showLessItems
              responsive={true}
            />

            {canDeleteWorkOrder && (
              <>
                <div className="mt-3" style={{ fontWeight: "900" }}>
                  Number of work order will be deleted: {selectedCount}
                </div>
                <div className="mt-3 d-flex gap-3">
                  <div>
                    {/* Add delete button for delete work order */}
                    <div>
                      <Button
                        type="primary"
                        danger
                        onClick={openDeletePopUp} // Open the modal on button click
                        // onClick={(i, d) => handleDeleteWorkOrder(i, d)}
                        disabled={selectedWorkOrderToDelete.length === 0}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>

                  <div className="">
                    {/* Add delete button for delete work order */}
                    <div>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSelectAllTheWorkOrder} // Call the function when clicked
                      >
                        {selectedWorkOrderToDelete.length === workOrders.length
                          ? "Deselect All"
                          : "Select All"}
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Sidebar>
        }
      >
        {openGoogleMap ? (
          <>
            <div className="contentclss">
              <div
                className="google_map_container"
                style={{ height: "700px", width: "100%" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                    }}
                  >
                    Show the Completed Jobs
                  </h1>

                  <button
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#1c449c",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "16px",
                    }}
                    onClick={handleShowCompleted}
                  >
                    Show the complete jobs
                  </button>
                </div>
                <Wrapper
                  apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                  render={(status) => <h1>{status}</h1>}
                >
                  <div
                    id="map"
                    // onClick={handleOpenGoogleMapDetailsModal}
                    style={{ height: "100%", width: "100%" }}
                    ref={(ref) => {
                      if (ref && !mapInstance) {
                        const map = new window.google.maps.Map(ref, {
                          center: { lat: 43.4142989, lng: -124.2301242 },
                          zoom: 5,
                          mapId: "DEMO_MAP_ID",
                        });

                        // map.addListener("click", onMapClick);
                        handleMapLoad(map);
                      }
                    }}
                  />
                </Wrapper>
              </div>
            </div>

            {/* google map details modal */}
            <Modal
              open={openGoogleMapDetailsModal}
              onCancel={handleCloseGoogleMapDetailsModal}
              footer={null}
              centered
              className="bottom-modal"
            >
              <div className="modal-content-container">
                <div>
                  <h3>{selectedWorkOrderDataDisplayToMapModal.tranId}</h3>
                </div>
                {/* quick buttons */}
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <a
                    href={`tel:${selectedWorkOrderDataDisplayToMapModal.contact_details?.phone}`}
                    className="quick_reply_buttons"
                  >
                    <IoCall size={22} />
                    <p>Call</p>
                  </a>

                  <button
                    className="quick_reply_buttons"
                    onClick={() => {
                      const lat =
                        selectedWorkOrderDataDisplayToMapModal.position.lat;
                      const lng =
                        selectedWorkOrderDataDisplayToMapModal.position.lng;

                      if (lat && lng) {
                        window.open(
                          `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    <FaMap size={22} />
                    <p>Navigate</p>
                  </button>

                  <button
                    className="quick_reply_buttons"
                    onClick={() =>
                      redirectToWorkOrderPage(
                        selectedWorkOrderDataDisplayToMapModal.tranId
                      )
                    }
                    type="primary"
                  >
                    {/* <FaMap size={22} /> */}
                    <p>Go to WorkOrder</p>
                  </button>
                </div>
                {/* details section */}
                <div className="details_section">
                  <div className="details_section_div_style">
                    <h5>Order Number</h5>
                    <h6>{selectedWorkOrderDataDisplayToMapModal.tranId}</h6>
                  </div>
                  <div className="details_section_div_style">
                    <h5>Total Survay Count</h5>
                    <h6>
                      {selectedWorkOrderDataDisplayToMapModal.totalSurvayCount}
                    </h6>
                  </div>
                  <div className="details_section_div_style">
                    <h5>Appoitment Time</h5>
                    <h6>{selectedWorkOrderDataDisplayToMapModal.apptDate}</h6>
                  </div>
                  <div className="details_section_div_style">
                    <h5>Job Type</h5>
                    <h6>{selectedWorkOrderDataDisplayToMapModal.jobType}</h6>
                  </div>
                  {/* <div className="details_section_div_style">
                    <h5>Point of Contact</h5>
                    <h6>
                      {selectedWorkOrderDataDisplayToMapModal.point_of_contact}
                    </h6>
                  </div> */}
                  <div className="details_section_div_style">
                    <h5>Location</h5>
                    <h6>{selectedWorkOrderDataDisplayToMapModal.address}</h6>
                  </div>
                  <div className="details_section_div_style">
                    <h5>Contact Details</h5>
                    {/* <h6>Email:</h6> */}
                    <h6>
                      <b>Phone Number </b>:
                      {
                        selectedWorkOrderDataDisplayToMapModal.contact_details
                          ?.phone
                      }
                    </h6>
                  </div>
                  <div className="details_section_div_style">
                    <h5>Status</h5>
                    <h6>{selectedWorkOrderDataDisplayToMapModal.status}</h6>
                  </div>
                </div>
              </div>
            </Modal>
          </>
        ) : (
          <>
            <div className="contentclss">
              <div className="d-flex justify-content-between align-items-center">
                <div className="ordercls">Order #{tranId}</div>

                {/* <button
                  type="primary"
                  className="sync_button"
                  onClick={() => {
                    handleIndividualSync();
                  }}
                  // style={{ color: activeContent === "Sync" ? "white" : "#c2cddd" }}
                >
                  <div className="fonticon">
                    <AiOutlineSync />
                  </div>
                  Sync #{tranId}
                </button> */}
              </div>

              <SubHeader2 arg={{ setActiveComponent, activeComponent }} />

              <div className="sub2container">
                {activeComponent === "info" ? (
                  <Info
                    tranId={tranId}
                    fetchWorkOrders={fetchWorkOrders}
                    isRefresh={isRefresh}
                    handleDateSortClick={handleDateSortClick}
                  />
                ) : null}
                {activeComponent === "tasks" ? (
                  <Task
                    tranId={tranId}
                    apptStatus={apptStatus}
                    priority={priority}
                    reconciliationStatus={reconciliationStatus}
                    specialInstructions={specialInstructions}
                    techName={techName}
                    isRefresh={isRefresh}
                  />
                ) : null}
                {activeComponent === "notes" ? (
                  <Notes tranId={tranId} isRefresh={isRefresh} hideTaskNotes={true} />
                ) : null}
                {activeComponent === "closing-questioner" ? (
                  <ClosingQuestioner tranId={tranId} isRefresh={isRefresh} />
                ) : null}
              </div>
            </div>
          </>
        )}

        {/* delete confirm modal */}
        <Modal
          title="Confirm Deletion"
          open={isModalOpen}
          onOk={handleDeleteWorkOrder} // Perform delete on confirmation
          okText="Delete" // Change the OK button text to "Delete"
          okButtonProps={{ danger: true }} // Apply danger color to the button
          onCancel={handleCancel} // Close modal without deleting
          centered
        >
          <div className="mt-4" style={{ fontSize: "16px" }}>
            Are you sure you want to delete{" "}
            <span style={{ fontWeight: "900", fontSize: "18px" }}>
              {selectedCount}
            </span>{" "}
            work order(s)?
          </div>
        </Modal>
      </Layout>
    </>
  );
};

export default Index;
